export const UsersBadge = () => {
  const avatars = [
    "https://i.pravatar.cc/100?img=1",
    "https://i.pravatar.cc/100?img=2",
    "https://i.pravatar.cc/100?img=3",
  ];

  return (
    <div className="flex flex-col items-center lg:items-start">

      {/* AVATARS + COUNT */}
      <div className="flex items-center gap-6">
        <div className="flex items-center">
          {avatars.map((src, i) => (
            <img
              key={i}
              src={src}
              alt="community member"
              className={`
                w-8 h-8 lg:w-12 lg:h-12
                rounded-full object-cover border-2 border-white
                ${i !== 0 ? "-ml-4" : ""}
              `}
            />
          ))}
        </div>

        <div className="text-[30px] lg:text-[44px] font-normal text-neutral-900">
          10k+
        </div>
      </div>

      {/* TEXT */}
      <p className="
        mt-2 text-[14px] text-neutral-800 leading-snug
        text-center lg:text-left
        max-w-[250px]
      ">
        Join the coupon community and experiencing more every day.
      </p>

    </div>
  );
};